import { render, staticRenderFns } from "./SingleLayerComplexStyle.vue?vue&type=template&id=79842bea&scoped=true"
import script from "./SingleLayerComplexStyle.vue?vue&type=script&lang=ts"
export * from "./SingleLayerComplexStyle.vue?vue&type=script&lang=ts"
import style0 from "./SingleLayerComplexStyle.vue?vue&type=style&index=0&id=79842bea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79842bea",
  null
  
)

export default component.exports